import { DocumentMetadata } from '@core-lib/modules/document-ged/models/alfresco.model';
import { createEntitySlice, IStoreEntityStateSlice } from '..';

export interface IAlfrescoDocumentsStoreState {
	coordonneesBancairesDocuments: IStoreEntityStateSlice<DocumentMetadata[]>;
}

export const initialState: IAlfrescoDocumentsStoreState = {
	coordonneesBancairesDocuments: createEntitySlice()
};
